import { SystemStyleObject } from "@mui/system";
import { Theme, alpha } from "@mui/material/styles";

import { boxShadowBlack } from "theme";

import { HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE } from "utils/styles";

const subHeaderStyles = {
  positionRelative: {
    position: "relative",
    overflow: "hidden",
    ...boxShadowBlack,
  },
  wrapper: (
    theme: Theme,
    isBackgroundSet?: boolean,
  ): SystemStyleObject<Theme> => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    ...(isBackgroundSet ? { height: "48vh" } : { minHeight: "48vh" }),
    textAlign: "center",
    pt: HEADER_HEIGHT_DESKTOP / 8,
    paddingBottom: isBackgroundSet ? 0 : 2,
    backgroundColor: theme.palette.background.default,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    [theme.breakpoints.down("lg")]: {
      ...(isBackgroundSet ? { height: "40vh" } : { minHeight: "40vh" }),
      pt: HEADER_HEIGHT_MOBILE / 8,
    },
    [theme.breakpoints.down("md")]: {
      ...(isBackgroundSet ? { height: "330px" } : { minHeight: "30vh" }),
    },
    [theme.breakpoints.down("sm")]: {
      ...(isBackgroundSet ? { height: "28vh" } : { minHeight: "25vh" }),
    },
  }),
  modifiedWrapper: (theme: Theme): SystemStyleObject<Theme> => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "50vh",
    backgroundPosition: "50%",
    backgroundSize: "cover",
    textAlign: "center",
    pt: HEADER_HEIGHT_DESKTOP / 8,
    pb: 2,

    [theme.breakpoints.down("lg")]: {
      minHeight: "25vh",
      pt: HEADER_HEIGHT_MOBILE / 8,
    },
  }),
  image: (
    theme: Theme,
    {
      isBackgroundSet,
      isBackgroundGradient,
      url,
    }: {
      isBackgroundSet?: boolean;
      isBackgroundGradient?: boolean;
      url?: string;
    },
  ): SystemStyleObject<Theme> => ({
    backgroundImage: isBackgroundGradient
      ? `linear-gradient(0deg, ${alpha(
          theme.palette.background.default,
          0.8,
        )}, ${alpha(theme.palette.background.default, 0.4)}), url('${url}')`
      : `url('${url}')`,
    width: "100%",
    backgroundPosition: "50%",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 99,
    ...(isBackgroundSet ? { height: "inherit" } : { minHeight: "inherit" }),
  }),
  light: (theme: Theme): SystemStyleObject<Theme> => ({
    color: theme.palette.text.secondary,
  }),
  dark: (theme: Theme): SystemStyleObject<Theme> => ({
    color: theme.palette.text.primary,
  }),
};

export default subHeaderStyles;
